import { render } from "./CalculatedResult.html?vue&type=template&id=0b7a8314"
import script from "./CalculatedResult.js?vue&type=script&lang=js"
export * from "./CalculatedResult.js?vue&type=script&lang=js"

import "./CalculatedResult.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__